import { NotificationManager } from "react-notifications";

export const checkLogin = function(ajax: JQuery.jqXHR): void {
    if (ajax.status === 401) {
        window.location.href = "/login";
    }
};

export const checkLogin2 = function(response: AxiosResponse): void {
    if (401 == response.status) {
        window.location.href = "/login";
    }
};


export const notifyServerErrorOrDefault = (ajax: JQuery.jqXHR, defaultMessage: string): void => {
    checkLogin(ajax);

    if (ajax.responseJSON && ajax.responseJSON.error) {
        NotificationManager.error(ajax.responseJSON.error);
    } else {
        NotificationManager.error(defaultMessage);
    }
};


import { AxiosResponse } from "axios";
export const notifyServerErrorOrDefault2 = (response: AxiosResponse, defaultMessage: string): void => {
    checkLogin2(response);

    let message = defaultMessage;
    if (response.data) {
        const { error } = response.data;
        if (error) {
            message = error;
        }
    }
    NotificationManager.error(message);
};
